import React from 'react'
import { CheckmarkBackgroundIcon, BodyText } from '@paypalcorp/pp-react'

import { Message, injectWorldReady } from '@paypalcorp/worldready-react'

function DoneTesting() {
  return (
    <div
      style={{
        textAlign: 'center',
        width: '100%',
        padding: '0 3rem 1rem 3rem',
      }}
    >
      <CheckmarkBackgroundIcon
        style={{ color: '#388C00', verticalAlign: 'inherit' }}
      />
      <br />
      <BodyText strong>
        <Message id="onboarding-banner.doneTesting" />
      </BodyText>
      <BodyText>
        <Message id="onboarding-banner.doneTestingStatement" />
      </BodyText>
    </div>
  )
}

export default injectWorldReady(DoneTesting)
